import React from "react";
import { useGetContactsQuery } from "../../redux/service/demographic_services";
import { AppListing } from "../../components/appListing";

function Contact({ crossHandler }) {
  const { data: contactData, isLoading } = useGetContactsQuery();
  const cols = [
    {
      title: "Contact",
      getData: (data) => {
        console.log(data,"heree")
        return data?.fname + " " + data?.lname;
      },
    },
    { title: "Type", key: "address_type_title" },
    { title: "Relation", key: "relationship_title" },
    {
      title: "Support",
      getData: (data) => {
        return data?.support_contact && data?.support_contact != "0"
          ? "Yes"
          : "No";
      },
    },
    {
      title: "Phone",
      getData: (data) => {
        return data?.phone?.phone;
      },
    },
  ];
  return (
    <div>
      <div className="flex rounded border-gray-300 bg-gray-200 px-3 py-3 sm:px-4 flex-wrap items-center justify-between sm:flex-nowrap">
        <p className="text-lg font-bold">Contact</p>
        <div onClick={crossHandler}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18 18 6M6 6l12 12"
            />
          </svg>
        </div>
      </div>
      <div className="mt-3">
        <AppListing
          loading={isLoading}
          listData={contactData?.data || []}
          cols={cols}
        />
      </div>
    </div>
  );
}

export default Contact;
